import React from "react";
import Sale from "../../../../utilities/data/model/Sale";

export type LaybyRootScreenContextType = {
  // A valid sale that can be used to create a quote
  sale: Sale;
};

export const LaybyRootScreenContext = React.createContext<
  LaybyRootScreenContextType | undefined
>(undefined);
